import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useAuth() {
  const qc = useQueryClient();
  const meQuery = useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await api.me();
      } catch {
        return { user: { email: null } };
      }
    },
    retry: false,
    staleTime: 60_000,
  });

  const login = useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) => api.login(email, password),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['me'] });
    },
  });

  const logout = useMutation({
    mutationFn: () => api.logout(),
    onSuccess: () => {
      qc.clear();
    },
  });

  return {
    user: meQuery.data?.user ?? { email: null },
    isAuthenticated: Boolean(meQuery.data?.user.email),
    isLoading: meQuery.isLoading,
    login,
    logout,
  };
}
